import Tribute from 'tributejs';
import Trix from 'trix';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['field'];

  static values = {
    resource: String,
    organization: String,
  };

  connect() {
    this.editor = this.fieldTarget.editor;
    this.initializeTribute();
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget);
  }

  initializeTribute() {
    this.tribute = new Tribute({
      allowSpaces: true,
      lookup: 'full_name',
      values: this.debounce(this.fetchUsers.bind(this)),
      menuItemTemplate(item) {
        return item.original.content;
      },
      // menuContainer: document.getElementById("comment-text-area")
    });
    this.tribute.attach(this.fieldTarget);
    // eslint-disable-next-line no-underscore-dangle
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this);
    this.fieldTarget.addEventListener('tribute-replaced', this.replaced);
  }

  // eslint-disable-next-line class-methods-use-this
  fetchUsers(text, callback) {
    fetch(`/mentions.json?q=${text}&resource=${this.resourceValue}&organization=${this.organizationValue}`)
      .then((response) => response.json())
      .then((users) => callback(users))
      .catch(() => callback([]));
  }

  // debouncer
  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  replaced(e) {
    const mention = e.detail.item.original;
    const attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.inline_content,
    });
    this.editor.insertAttachment(attachment);
    this.editor.insertString(' ');
  }

  // eslint-disable-next-line no-underscore-dangle
  _pasteHtml(_html, startPos, endPos) {
    const position = this.editor.getPosition();
    this.editor.setSelectedRange([position - endPos + startPos, position + 1]);
    this.editor.deleteInDirection('backward');
  }
}
